import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { LanguageService } from '../../core/language.service';

@Component({
  selector: 'app-code-input',
  templateUrl: './code-input.component.html',
  styleUrls: ['./code-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CodeInputComponent {
  public code: string = '';

  constructor(private readonly languageService: LanguageService) {
    languageService.initialize();
  }
  @Output() readonly codeComplete = new EventEmitter<string>();
  onClick(): void {
    this.codeComplete.emit(this.code);
  }

  filterDigits(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');
    this.code = inputElement.value;
  }
}
